/* 特斯拉股票行权 */
export default [
    {
      path: '/wage/teslaArrears',
      name: '欠款管理',
      component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/tesla/debtManagement.vue`),
      meta: {
        permission: ['set_email_management_debt']
      }
    },
    {
      path: '/wage/debtDetails',
      name: '详情',
      component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/tesla/debtDetails.vue`),
      meta: {
        permission: ['set_email_management_debt']
      }
    },
    {
      path: '/wage/teslaEmali',
      name: '邮件设置',
      component: () => import ( /* webpackChunkName: "table" */ `@/views/wage/tesla/emailSetting.vue`),
      meta: {
        permission: ['set_email_management_mailSet']
      }
    }
    ]
